import { render } from "./manage-api-connect-trigger.vue?vue&type=template&id=ff631968"
import script from "./manage-api-connect-trigger.vue?vue&type=script&lang=js"
export * from "./manage-api-connect-trigger.vue?vue&type=script&lang=js"
script.render = render

export default script